const findClosest = require("./closest_value");

function determineVesselType(trim, fouling, trimsList, foulingList) {
  const vesselTrim = findClosest(trimsList, trim);
  const vesselFouling = findClosest(foulingList, fouling);

  return {
    "trim": vesselTrim,
    "fouling": vesselFouling
  };
}

module.exports = determineVesselType;
